import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsReason } from '../../data-provider/select-options';

export const useGetPreClaimsReasonList = () => {
  return useQuery({
    queryKey: ['pre-claims-reason-list'],
    queryFn: () => fetchPreClaimsReason(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
